import { render, staticRenderFns } from "./ForgotPassword.vue?vue&type=template&id=be85c97a"
import script from "./ForgotPassword.vue?vue&type=script&lang=js"
export * from "./ForgotPassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\dev\\hubee\\hubee-backoffice-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('be85c97a')) {
      api.createRecord('be85c97a', component.options)
    } else {
      api.reload('be85c97a', component.options)
    }
    module.hot.accept("./ForgotPassword.vue?vue&type=template&id=be85c97a", function () {
      api.rerender('be85c97a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/ForgotPassword.vue"
export default component.exports